import { FC } from 'react'
import { useCustomTheme } from '@atbay/theming'
import Typography from '@/ui/components/typography'
import { BannerWrapper, PulsingDot, TextColumn } from './BecAlertBanner.styles'
import { BecAlertBannerProps } from './BecAlertBanner.types'

const BecAlertBanner: FC<BecAlertBannerProps> = ({ count }) => {
    const theme = useCustomTheme()

    const description =
        count === 1
            ? `${count} mailbox may have been taken over. Review suspicious rules and secure it now.`
            : `${count} mailboxes may have been taken over. Review suspicious rules and secure them now.`

    return (
        <BannerWrapper data-testid="bec-alert-banner" role="alert">
            <PulsingDot />
            <TextColumn>
                <Typography
                    variant="s-semibold"
                    color={theme.colors.semantic.error}
                >
                    Immediate action required
                </Typography>
                <Typography
                    variant="xs-regular"
                    color={theme.colors.greys[600]}
                    noWrap={false}
                >
                    {description}
                </Typography>
            </TextColumn>
        </BannerWrapper>
    )
}

export default BecAlertBanner
